export default __webpack_public_path__ + "static/media/ic-pdf1.4e393b1d.svg";